import { render, staticRenderFns } from "./TilesetModal.vue?vue&type=template&id=22e0f8e2&scoped=true&"
import script from "./TilesetModal.vue?vue&type=script&lang=js&"
export * from "./TilesetModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0f8e2",
  null
  
)

export default component.exports